<template>
  <v-container ref="projectTypeStageContainer" fluid :style="'height:'+$store.getters['general/availableHeight']+'px;'">
		<div class="d-flex align-center justify-space-between white pa-2" style="height: 40px;border:1px solid #ccc!important;">
			<div></div>
			<p class="mb-0 text-center caption font-weight-bold">Incluye</p>
			<div class="d-flex align-center">
				<v-tooltip bottom>
					<template v-slot:activator="{ on, attrs }">
						<v-btn
							outlined
							dark
							x-small
							color="black"
							class="mx-1"
							@click.stop="$router.push({ name: 'ProjectTypes' })"
							v-bind="attrs"
							v-on="on"
						>
							<v-icon small dark>mdi-format-list-bulleted-square</v-icon>
							<p class="mb-0">Volver a Tipos de Proyectos</p>
						</v-btn>
					</template>
					<span>Ver Listado de Tipos de Proyectos</span>
				</v-tooltip>
				<v-btn
					outlined
					dark
					x-small
					color="green"
					class="ml-1"
					@click="addNewStage = true"
				>
					<v-icon small dark>mdi-plus</v-icon>
					<p class="mb-0">Agregar Etapa</p>
				</v-btn>
			</div>
		</div>
		<v-simple-table
			ref="myTable"
			class="custom-table-cost caption"
			fixed-header
			:height="containerContentHeight - 40"
			>
			<template v-slot:default>
				<thead class="table-header-fixed white">
					<tr style="z-index: 999">
						<th width="200" style="z-index: 1000"></th>
						<th class="caption font-weight-bold">Tipo Proyecto</th>
						<th v-for="stage in companyPlanningStages" :key="'st-'+stage.id">
							<p class="mb-0 text-center" style="font-size: 10px;">{{stage.name}}</p>
							<v-btn
								icon
								dark
								x-small
								color="error"
								style="position:absolute; top: 0; right: 0;"
								@click="deleteCompanyStage(stage.id)"
							>
								<v-icon small dark>mdi-delete-outline</v-icon>
							</v-btn>
						</th>
						<th v-if="addNewStage" style="width: 200px;">
							<div>
								<v-text-field
									v-model="newStageName"
									outlined
									required
									dense
									label="Nueva Etapa"
									class="custom-height-search custom-height-calendar"
									hide-details
								></v-text-field>
								<div class="mt-2 d-flex" style="width: 100%">
									<v-btn
										depressed
										color="#FF120B"
										x-small
										dark
										class="mr-1 d-flex flex-grow-1"
										:loading="loadingStages"
										@click="saveNewStage()"
									>
										<v-icon small>mdi-check</v-icon>
									</v-btn>
									<v-btn
										depressed
										color="#959595"
										x-small
										dark
										:loading="loadingStages"
										@click="cancelNewStage()"
									>
										<v-icon small>mdi-close</v-icon>
									</v-btn>
								</div>
							</div>
						</th>
					</tr>
				</thead>
				<tbody v-for="(category, index) in $store.state.companies.companiesProjectTypesCategories" :key="'pt_'+category.id">
					<tr class="grey"
						:class="{ 'lighten-1': index%2 == 0, 'lighten-3': index%2 != 0 }">
						<td :rowspan="projectTypesFlat.filter(pt => pt.category_id == category.id).length + 1" class="category-cell">
							<div class="category-content">
								<div class="category-sticky-wrapper">
									<p class="mb-0 caption font-weight-bold category-name">{{ category.name }}</p>
								</div>
							</div>
						</td>
					</tr>
					<template v-for="item in projectTypesFlat.filter(pt => pt.category_id == category.id)">
						<tr
							v-if="item.isParentTitle"
							:key="item.id"
							:class="{ 'grey lighten-3': item.isParentTitle }"
						>
							<td :colspan="companyPlanningStages.length + 1" class="py-0" style="height: 30px;">
								<div>
									<p class="caption mb-0 font-weight-bold">{{ item.name }}</p>
								</div>
							</td>
						</tr>
						<tr
							v-else
							:key="'pt'+item.id"
						>
							<td style="cursor: pointer;width: 300px;">
								<div class="ml-2" v-if="item.isSubType">
									<p class="mb-0 font-weight-bold text--disabled" style="font-size: 10px;">{{ item.parentName }}</p>
									<p class="caption mb-0 font-weight-bold">[{{ item.code }}] {{ item.name }}</p>
									<p class="caption mb-0">{{ item.description }}</p>
								</div>
								<div class="ml-2" v-else>
									<p class="caption mb-0 font-weight-bold">[{{ item.code }}] {{ item.name }}</p>
									<p class="caption mb-0">{{ item.description }}</p>
								</div>
							</td>
							<td v-for="stage in companyPlanningStages" :key="'st-'+stage.id" class="text-center" style="width: 120px;">
								<div class="d-flex justify-center align-center fill-height">
									<v-checkbox
										:input-value="item.includes?.includes(stage.id)"
										dense
										hide-details
										color="black"
										class="caption my-0 py-0 custom-checkbox"
										@change="onChangeItemIncludes(item, stage)"></v-checkbox>
								</div>
							</td>
							<td v-if="addNewStage" style="width: 200px;"></td>
						</tr>
					</template>
				</tbody>
			</template>
		</v-simple-table>
  </v-container>
</template>

<script>
import {updateProjectType, createCompanyStage, deleteCompanyStage} from '@/helpers/api/company'
import _debounce from 'lodash/debounce'

export default {
  components: {},
  data() {
    return {
			addNewStage: false,
			loadingStages: false,
			newStageName: null,
      debouncedUpdates: {},
      containerContentHeight: 0,
      resizeObserver: null,
			scrollTop: 0
    };
  },
  computed: {
		projectTypesFlat() {
			const result = [];

			this.$store.state.companies.companiesProjectTypesCategories.forEach(category => {
				category.project_types.forEach(pt => {
					result.push({
						...pt,
						isParentTitle: true
					});
					// result.push({
					// 	...pt,
					// 	isParent: true
					// });
					pt.sub_types.forEach(st => {
						result.push({
							...st,
							isSubType: true,
							parentId: pt.id,
							parentName: pt.name
						});
					});
				});
			});
			return result;
		},
		companyPlanningStages(){
			return this.$store.state.companies.companyPlanningStages
		},
		selectedCompany(){
			return this.$store.state.companies.selectedCompany
		}
  },
	watch: {
		selectedCompany(newValue){
			if(newValue){
				this.reloadInfo()
			}
		}
	},
	mounted(){
		if(this.selectedCompany){
			this.reloadInfo()
		}
		const selectedRow = JSON.parse(localStorage.getItem('selected_prjecttypeslist_row'));
		if (selectedRow) {
			this.selectedRowItem = selectedRow
		}
		this.$nextTick(() => {
			const wrapper = this.$refs.myTable.$el.querySelector('.v-data-table__wrapper');
			if (wrapper) {
				wrapper.addEventListener('scroll', this.onScroll);
			}
			this.observeResize();
		});
  },
  beforeDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  },
  methods: {
		onScroll(event){
			this.scrollTop = event.target.scrollTop
			this.updateStickyCategories(event.target.scrollTop)
		},
		updateStickyCategories() {
			this.$nextTick(() => {
				const categoryElements = document.querySelectorAll('.category-cell');
				
				categoryElements.forEach((categoryCell) => {
					const stickyWrapper = categoryCell.querySelector('.category-sticky-wrapper');
					if (!stickyWrapper) return;
					
					const cellRect = categoryCell.getBoundingClientRect();
					const tableWrapper = this.$refs.myTable.$el.querySelector('.v-data-table__wrapper');
					const wrapperRect = tableWrapper.getBoundingClientRect();
					const tableHeader = this.$refs.myTable.$el.querySelector('thead');
					const headerHeight = tableHeader ? tableHeader.offsetHeight : 0;
					const cellTop = cellRect.top - wrapperRect.top;
					const cellBottom = cellRect.bottom - wrapperRect.top;
					const cellHeight = cellRect.height;
					const stickyHeight = stickyWrapper.offsetHeight;
					
					let translateY = 0;
					
					if (cellTop < headerHeight && cellBottom > headerHeight + stickyHeight) {
						translateY = headerHeight - cellTop;
						translateY = Math.min(translateY, cellHeight - stickyHeight);
					}
					else if (cellTop >= headerHeight) {
						translateY = 0;
					}
					else if (cellBottom <= headerHeight + stickyHeight) {
						translateY = cellHeight - stickyHeight;
					}
					
					stickyWrapper.style.transform = `translateY(${translateY}px)`;
				});
			});
		},
    observeResize() {
      const el = this.$refs.projectTypeStageContainer;
			console.log(el)
      if (!el) return;

      this.resizeObserver = new ResizeObserver(() => {
        const style = getComputedStyle(el);
        const height = el.clientHeight;
        const paddingTop = parseFloat(style.paddingTop);
        const paddingBottom = parseFloat(style.paddingBottom);

        this.containerContentHeight = height - paddingTop - paddingBottom;
      });

      this.resizeObserver.observe(el);
    },
		async saveNewStage(){
			this.loadingStages = true
			await createCompanyStage({
				name: this.newStageName,
				company_id: this.selectedCompany.id
			})
			this.$store.dispatch('companies/getCompanyPlanningStages')
			this.loadingStages = false
			this.cancelNewStage()
		},
		cancelNewStage(){
			this.addNewStage = false
			this.newStageName = null
		},
		async deleteCompanyStage(company_stage_id){
			await deleteCompanyStage({company_stage_id})
			this.$store.dispatch('companies/getCompanyPlanningStages')
		},
		editProjectTypesIncludes(status){
			this.$store.commit('companies/setEditProjectTypesIncludes', status)
		},
		onChangeItemIncludes(item, stage) {
			const id = item.id;

			const itemCopy = item;
			itemCopy.includes = Array.isArray(itemCopy.includes) ? [...itemCopy.includes] : [];

			const stageId = String(stage.id);
			const includesAsStrings = itemCopy.includes.map(i => String(i));
			const index = includesAsStrings.indexOf(stageId);

			if (index === -1) {
				itemCopy.includes.push(stage.id);
			} else {
				itemCopy.includes.splice(index, 1);
			}
			if (!this.debouncedUpdates[id]) {
				this.debouncedUpdates[id] = _debounce((itemToUpdate) => {
					this.updateProjectTypeInfo(itemToUpdate, false);
				}, 1500);
			}

			this.debouncedUpdates[id](itemCopy);
		},
		async updateProjectTypeInfo(item, reload = true){
			const data = {
				...{project_type_id: item.id},
				...item
			}
			await updateProjectType(data)
			reload && this.reloadInfoDebounced()
		},
		selectRow(item){
			this.selectedRowItem = item.id
			localStorage.setItem('selected_prjecttypeslist_row', JSON.stringify(item.id))
		},
		selectedRowClass(item){
			if (this.selectedRowItem && this.selectedRowItem === item.id) {
				return 'selected-row-custom-item';
			}
			return ''
		},
		reloadInfoDebounced: _debounce(function(){ this.reloadInfo() }, 1000),
		reloadInfo(){
			this.$store.dispatch('companies/getCompanyProjectTypes')
		},
  },
};
</script>

<style>
	.custom-checkbox .v-input--selection-controls__input{
		margin-right: 0;
	}
	.custom-table-cost table {
		border-collapse: collapse;
	}
	.custom-table-cost table td,
	.custom-table-cost table th{
		border: 1px solid #ccc;
	}
	
	/* Sticky category cell styles */
	.category-cell {
		position: relative;
		vertical-align: top;
		padding: 0 !important;
		overflow: hidden;
	}
	
	.category-content {
		height: 100%;
		position: relative;
		overflow: hidden;
	}
	
	.category-sticky-wrapper {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		padding: 8px 16px;
		z-index: 10; /* Aumenté el z-index para que esté sobre el header */
		/* transition: transform 0.1s ease; */
		/* Ensure proper sizing */
		box-sizing: border-box;
	}
	
	.category-name {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	
	td.sticky-cell {
		position: sticky;
		top: 1px;
		z-index: 2;
		border: 1px solid red!important;
	}
</style>